<div class="acf-wrapper">

    <!-- ══════════════════════════════════════════════════════════
       TOP BAR
  ══════════════════════════════════════════════════════════ -->
    <header class="acf-header">
        <div class="acf-header__left">
            <span class="acf-header__icon">⬡</span>
            <div>
                <p class="acf-header__sub">Asset Management</p>
                <h1 class="acf-header__title">Device Configuration</h1>
            </div>
        </div>

        <div class="acf-header__right">
            <!-- <div class="master-switcher">
                <button *ngFor="let mt of [4, 1, 2, 3]" [class.master-switcher__btn--active]="masterType == mt"
                    class="master-switcher__btn" (click)="masterType = mt; loadFormData()">
                    <div [ngSwitch]="mt">

                        <div *ngSwitchCase="'1'">
                            Em-Mini Configuration Fields
                        </div>

                        <div *ngSwitchCase="'2'">
                            Em-Saver Configuration Fields
                        </div>

                        <div *ngSwitchCase="'3'">
                            EMSaver + RTDs Configuration Fields
                        </div>

                        <div *ngSwitchCase="'4'">
                            Piezo Configuration Fields
                        </div>

                    </div>
                </button>
            </div> -->

            <span class="device-badge" [class.device-badge--piezo]="isPiezo" [class.device-badge--ems]="isEmsaver">
                {{ masterType==4 ? '⬡ Piezo' : masterType ==3 ? '◈ EMSaver + RTDs' : masterType == 2 ? '◈ EMsaver' : '◈
                EM-Mini' }}
            </span>
        </div>
    </header>

    <!-- ── LOADING ── -->
    <div class="acf-loader" *ngIf="loading">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Loading <strong>{{ masterLabel }}</strong> configuration…</p>
    </div>

    <!-- ══════════════════════════════════════════════════════════
       FORM
  ══════════════════════════════════════════════════════════ -->
    <form [formGroup]="form" class="acf-form" *ngIf="!loading" (ngSubmit)="saveForm()">

        <!-- ── ASSET TYPE SELECTOR ── -->
        <div class="asset-type-bar">
            <span class="asset-type-bar__label">Asset Type</span>
            <button *ngFor="let at of ASSET_TYPES" type="button" class="asset-type-btn "
                [class.asset-type-btn--active]="assetType === at" (click)="onAssetTypeChange(at)" disabled>
                {{ at | titlecase }}
            </button>
        </div>

        <!-- ══════════════════════════════════════════════════════════
         SECTION 1 — GENERAL DETAILS
    ══════════════════════════════════════════════════════════ -->
        <section class="acf-section">
            <div class="acf-section__head">
                <h2 class="acf-section__title">General Details</h2>
                <span class="acf-badge acf-badge--required">Required</span>
            </div>
            <div class="acf-row" formGroupName="general_details">
                <mat-form-field appearance="outline" class="acf-field">
                    <mat-label>Asset Name</mat-label>
                    <input matInput formControlName="asset_name" placeholder="Enter asset name">
                    <mat-hint>Only available for MASTER device</mat-hint>
                </mat-form-field>

                <mat-form-field appearance="outline" class="acf-field">
                    <mat-label>Site</mat-label>
                    <mat-select formControlName="site">
                        <mat-option *ngFor="let s of sites" [value]="s.id">{{ s.name }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="acf-field">
                    <mat-label>Application</mat-label>
                    <mat-select formControlName="application">
                        <mat-option *ngFor="let a of applications" [value]="a.id">{{ a.name }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </section>

        <mat-divider></mat-divider>

        <!-- ══════════════════════════════════════════════════════════
         SECTION 2 — DEVICE PUSH RATE CONFIG (EMsaver only)
    ══════════════════════════════════════════════════════════ -->
        <section class="acf-section" *ngIf="isEmsaver">
            <div class="acf-section__head">
                <h2 class="acf-section__title">Device Push Rate Configuration</h2>
                <span class="acf-badge acf-badge--ems">EMsaver Only</span>
            </div>
            <div formGroupName="device_push_rate_configuration">
                <div class="acf-row">
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>Summary Refresh Rate (mins)</mat-label>
                        <input matInput type="number" formControlName="summaryFileRefreshRate" placeholder="15">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>High-Res Push Rate (mins)</mat-label>
                        <input matInput type="number" formControlName="fullRefreshFileRate" placeholder="60">
                    </mat-form-field>
                </div>
                <div class="acf-row acf-row--two">
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>ODR Normal</mat-label>
                        <mat-select formControlName="odr_normal">
                            <mat-option *ngFor="let o of ODR_OPTIONS" [value]="o.value">{{ o.label }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>ODR High Res</mat-label>
                        <mat-select formControlName="odr_high_res">
                            <mat-option *ngFor="let o of ODR_OPTIONS" [value]="o.value">{{ o.label }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="acf-row acf-row--two">
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>Scan Rate (sec)</mat-label>
                        <input matInput type="number" formControlName="scanRate" placeholder="15">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>Machine Threshold</mat-label>
                        <input matInput type="number" formControlName="machine_threshold_status" placeholder="0.5">
                    </mat-form-field>
                </div>
                <div class="acf-row">
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>Anomaly Analysis (mins)</mat-label>
                        <input matInput type="number" formControlName="anomalyAnalysisTime" placeholder="180">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>Anomaly Counter</mat-label>
                        <input matInput type="number" formControlName="anomalyCounter" placeholder="1">
                    </mat-form-field>
                </div>
            </div>
        </section>

        <mat-divider *ngIf="isEmsaver"></mat-divider>

        <!-- ══════════════════════════════════════════════════════════
         SECTION 3 — CONFIGURATION DETAILS
    ══════════════════════════════════════════════════════════ -->
        <section class="acf-section">
            <div class="acf-section__head">
                <h2 class="acf-section__title">Configuration Details</h2>
            </div>
            <div formGroupName="configuration_details">

                <!-- Row A -->
                <div class="acf-row">
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>Line Current (A)</mat-label>
                        <input matInput type="number" formControlName="line_current" placeholder="0">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>Device Name</mat-label>
                        <input matInput formControlName="device_name" placeholder="Enter device name">
                        <mat-error
                            *ngIf="form.get('configuration_details.device_name')?.hasError('required')">Required</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>Motor Make</mat-label>
                        <input matInput formControlName="motor_make" placeholder="e.g. ABB, Siemens">
                        <mat-error
                            *ngIf="form.get('configuration_details.motor_make')?.hasError('required')">Required</mat-error>
                    </mat-form-field>
                </div>

                <!-- Row B: Device ID (MAC) + Serial Number -->
                <div class="acf-row">
                    <mat-form-field appearance="outline" class="acf-field acf-field--wide">
                        <mat-label>Device ID (MAC Address) *</mat-label>
                        <mat-select formControlName="mac_address" (selectionChange)="onMacAddressChange($event)">
                            <mat-option *ngFor="let d of device_inventory" [value]="d.id">
                                {{ d.mac_address }}
                            </mat-option>

                        </mat-select>
                        <!-- <mat-hint>Select from device inventory</mat-hint> -->
                        <mat-error
                            *ngIf="form.get('configuration_details.mac_address')?.hasError('required')">Required</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="acf-field acf-field--wide">
                        <mat-label>Serial Number</mat-label>
                        <input matInput formControlName="serial_number" placeholder="Auto-filled from device">
                        <!-- <mat-hint>Auto-populated on device selection</mat-hint> -->
                    </mat-form-field>
                </div>

                <!-- Row C: Equipment Location -->
                <div class="acf-row--three">
                    <mat-form-field appearance="outline" class="acf-field acf-field--full">
                        <mat-label>Equipment Location</mat-label>
                        <input matInput formControlName="equipment_location" placeholder="e.g. Plant Floor A - Bay 3">
                    </mat-form-field>
                </div>

                <!-- Row D: Frame, Amb Temp, Temp Unit, Insulation -->
                <div class="acf-row acf-row--two">
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>Frame</mat-label>
                        <input matInput formControlName="frame" placeholder="e.g. IEC 180">
                    </mat-form-field>
                    <div class="acf-row acf-row--two">
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Rated Ambient Temp.</mat-label>
                            <input matInput type="number" formControlName="rated_amb_temp" placeholder="40">
                        </mat-form-field>
                        <div class="acf-inline-radio">
                            <mat-radio-group formControlName="rated_amb_temp_unit" class="acf-radio-group">
                                <mat-radio-button value="C">°C</mat-radio-button>
                                <mat-radio-button value="F">°F</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>
                <div class="acf-row acf-row--two">
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>Insulation Class</mat-label>
                        <mat-select formControlName="insulation_class">
                            <mat-option *ngFor="let c of INSULATION_CLASSES" [value]="c">{{ c }}</mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="form.get('configuration_details.insulation_class')?.hasError('required')">Required</mat-error>
                    </mat-form-field>
                    <div class="acf-row acf-row--two">
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Rated Power</mat-label>
                            <input matInput type="number" formControlName="rated_power" placeholder="75">
                            <mat-error
                                *ngIf="form.get('configuration_details.rated_power')?.hasError('required')">Required</mat-error>
                        </mat-form-field>
                        <div class="acf-inline-radio">
                            <mat-radio-group formControlName="rated_power_unit" class="acf-radio-group">
                                <mat-radio-button value="KW">kW</mat-radio-button>
                                <mat-radio-button value="fi">HP</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>

                <!-- Row E: Power, RPM, RPM Type -->
                <div class="acf-row" *ngIf="!isGear">
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>Rated RPM</mat-label>
                        <input matInput type="number" formControlName="rated_rpm" placeholder="1480" min="0">
                        <mat-error
                            *ngIf="form.get('configuration_details.rated_rpm')?.hasError('required')">Required</mat-error>
                    </mat-form-field>
                    <div class="acf-inline-radio">
                        <mat-radio-group formControlName="rated_rpm_type" class="acf-radio-group">
                            <mat-radio-button value="fixed">Fixed</mat-radio-button>
                            <mat-radio-button value="variable">Variable</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <!-- Variable RPM: min/max -->
                <div class="acf-row acf-row--highlighted" *ngIf="isVariableRpm">
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>Min RPM</mat-label>
                        <input matInput type="number" formControlName="min_rpm" placeholder="0" min="0">
                        <mat-error
                            *ngIf="form.get('configuration_details.min_rpm')?.hasError('required')">Required</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>Max RPM</mat-label>
                        <input matInput type="number" formControlName="max_rpm" placeholder="3000">
                        <mat-error
                            *ngIf="form.get('configuration_details.max_rpm')?.hasError('required')">Required</mat-error>
                    </mat-form-field>
                </div>

                <!-- Row F: Voltage, Efficiency, Line Freq, PF -->
                <div class="acf-row">
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>Rated Voltage (V)</mat-label>
                        <input matInput type="number" formControlName="rated_voltage" placeholder="415">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>Efficiency (%)</mat-label>
                        <input matInput type="number" formControlName="percentage_eff" placeholder="92">
                    </mat-form-field>
                </div>
                <div class="acf-row">
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>Line Frequency</mat-label>
                        <input matInput type="number" formControlName="line_freq" placeholder="50">
                        <mat-error
                            *ngIf="form.get('configuration_details.line_freq')?.hasError('required')">Required</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>Power Factor</mat-label>
                        <input matInput type="number" formControlName="power_factor" placeholder="0.85">
                    </mat-form-field>
                </div>

                <!-- Row G: Duty + asset-specific fields -->
                <div class="acf-row">
                    <mat-form-field appearance="outline" class="acf-field">
                        <mat-label>Duty</mat-label>
                        <input matInput formControlName="duty" placeholder="e.g. S1">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="acf-field" *ngIf="isMotor">
                        <mat-label>Pole Pairs</mat-label>
                        <input matInput type="number" formControlName="pole_pairs" placeholder="2" min="0">
                    </mat-form-field>
                </div>
                <div class="acf-row acf-row--three">
                    <mat-form-field appearance="outline" class="acf-field" *ngIf="isPump">
                        <mat-label>No. of Blades</mat-label>
                        <input matInput type="number" formControlName="no_of_blades" placeholder="0" min="0">
                    </mat-form-field>
                </div>

                <!-- ── BEARING (hidden for GEAR) ── -->
                <ng-container *ngIf="!isGear">
                    <div class="acf-row">
                        <div class="acf-inline-radio">
                            <label class="acf-inline-radio__label">Bearing Type</label>
                            <mat-radio-group formControlName="bearing_type" class="acf-radio-group">
                                <mat-radio-button value="ball_bearing">Ball Bearing</mat-radio-button>
                                <mat-radio-button value="sleeve_bearing">Sleeve Bearing</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="acf-row">
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>DE Bearing Number</mat-label>
                            <mat-select formControlName="de_number">
                                <mat-option value="NA">N/A (Sleeve)</mat-option>
                                <mat-option *ngFor="let b of bearing_numbers" [value]="b.bearing_number">{{
                                    b.bearing_number
                                    }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>NDE Bearing Number</mat-label>
                            <mat-select formControlName="nde_number">
                                <mat-option value="NA">N/A (Sleeve)</mat-option>
                                <mat-option *ngFor="let b of bearing_numbers" [value]="b.bearing_number">{{
                                    b.bearing_number
                                    }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </ng-container>

            </div><!-- /formGroupName=configuration_details -->
        </section>

        <mat-divider></mat-divider>

        <!-- ══════════════════════════════════════════════════════════
         SECTION 4 — GEAR DETAILS (GEAR only)
    ══════════════════════════════════════════════════════════ -->
        <ng-container *ngIf="isGear" formGroupName="configuration_details">

            <!-- PINION GEAR -->
            <section class="acf-section">
                <div class="acf-section__head">
                    <h2 class="acf-section__title">Pinion Gear Details</h2>
                    <span class="acf-badge acf-badge--gear">Gear Only</span>
                </div>
                <div formGroupName="pinion_gear_details">
                    <div class="acf-row">
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>No. of Stages</mat-label>
                            <input matInput formControlName="no_of_stages" placeholder="e.g. 2">
                        </mat-form-field>
                    </div>
                    <div class="acf-row">
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Pinion Gear RPM</mat-label>
                            <input matInput type="number" formControlName="p_gear_rpm" placeholder="1480">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Pinion Gear Teeth</mat-label>
                            <input matInput type="number" formControlName="p_gear_teeth" placeholder="32">
                        </mat-form-field>
                    </div>
                    <div class="acf-row">
                        <div class="acf-inline-radio">
                            <label class="acf-inline-radio__label">Bearing Type</label>
                            <mat-radio-group formControlName="p_bearing_type" class="acf-radio-group">
                                <mat-radio-button value="ball_bearing">Ball Bearing</mat-radio-button>
                                <mat-radio-button value="sleeve_bearing">Sleeve Bearing</mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Pinion DE Bearing No.</mat-label>
                            <mat-select formControlName="p_deb_no">
                                <mat-option value="NA">N/A (Sleeve)</mat-option>
                                <mat-option *ngFor="let b of bearing_numbers" [value]="b.bearing_number">{{
                                    b.bearing_number
                                    }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Pinion NDE Bearing No.</mat-label>
                            <mat-select formControlName="p_ndeb_no">
                                <mat-option value="NA">N/A (Sleeve)</mat-option>
                                <mat-option *ngFor="let b of bearing_numbers" [value]="b.bearing_number">{{
                                    b.bearing_number
                                    }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </section>

            <!-- OUTPUT GEAR -->
            <section class="acf-section">
                <div class="acf-section__head">
                    <h2 class="acf-section__title">Output Gear Details</h2>
                    <span class="acf-badge acf-badge--gear">Gear Only</span>
                </div>
                <div formGroupName="output_gear_details">
                    <div class="acf-row">
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>No. of Output Gears</mat-label>
                            <input matInput type="number" formControlName="no_of_opt_gears" placeholder="1">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Output Gear RPM</mat-label>
                            <input matInput type="number" formControlName="o_gear_rpm" placeholder="740">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Output Gear Teeth</mat-label>
                            <input matInput type="number" formControlName="o_gear_teeth" placeholder="64">
                        </mat-form-field>
                    </div>
                    <div class="acf-row">
                        <div class="acf-inline-radio">
                            <label class="acf-inline-radio__label">Bearing Type</label>
                            <mat-radio-group formControlName="o_bearing_type" class="acf-radio-group">
                                <mat-radio-button value="ball_bearing">Ball Bearing</mat-radio-button>
                                <mat-radio-button value="sleeve_bearing">Sleeve Bearing</mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Output DE Bearing No.</mat-label>
                            <mat-select formControlName="o_deb_no">
                                <mat-option value="NA">N/A (Sleeve)</mat-option>
                                <mat-option *ngFor="let b of bearing_numbers" [value]="b.bearing_number">{{
                                    b.bearing_number
                                    }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Output NDE Bearing No.</mat-label>
                            <mat-select formControlName="o_ndeb_no">
                                <mat-option value="NA">N/A (Sleeve)</mat-option>
                                <mat-option *ngFor="let b of bearing_numbers" [value]="b.bearing_number">{{
                                    b.bearing_number
                                    }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </section>

            <!-- GMF -->
            <section class="acf-section">
                <div class="acf-section__head">
                    <h2 class="acf-section__title">Gear Mesh Frequency (GMF)</h2>
                    <span class="acf-badge acf-badge--gear">Gear Only</span>
                </div>
                <div formGroupName="gmf_details">
                    <div class="acf-row">
                        <div class="acf-inline-radio">
                            <label class="acf-inline-radio__label">Do you know the GMF?</label>
                            <mat-radio-group formControlName="is_gmf" class="acf-radio-group">
                                <mat-radio-button value="gmf_enabled">Yes</mat-radio-button>
                                <mat-radio-button value="gmf_disabled">No</mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <mat-form-field appearance="outline" class="acf-field" *ngIf="gmfEnabled">
                            <mat-label>No. of GMF</mat-label>
                            <mat-select formControlName="no_of_gmf">
                                <mat-option *ngFor="let n of GMF_COUNT_OPTIONS" [value]="n">{{ n }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <!-- GMF list rows -->
                    <div formArrayName="gmf_list">
                        <div *ngFor="let grp of gmfControls; let i = index" [formGroupName]="i"
                            class="acf-row acf-row--gmf">
                            <span class="acf-gmf-index">{{ i + 1 }}</span>
                            <mat-form-field appearance="outline" class="acf-field">
                                <mat-label>GMF Value [{{ i + 1 }}]</mat-label>
                                <input matInput formControlName="gmf_value">
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="acf-field">
                                <mat-label>Number For GMF [{{ i + 1 }}]</mat-label>
                                <input matInput formControlName="number_for_gmf">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </section>

            <mat-divider></mat-divider>
        </ng-container><!-- /isGear -->

        <!-- ══════════════════════════════════════════════════════════
         SECTION 5 — DRIVE DETAILS (hidden for GEAR)
    ══════════════════════════════════════════════════════════ -->
        <section class="acf-section" *ngIf="!isGear">
            <div class="acf-section__head">
                <h2 class="acf-section__title">Drive Details</h2>
            </div>
            <div formGroupName="drive_details">
                <div class="acf-row">
                    <div class="acf-inline-radio">
                        <label class="acf-inline-radio__label">Drive Type</label>
                        <mat-radio-group formControlName="drive_type" class="acf-radio-group">
                            <mat-radio-button value="direct">Direct Drive</mat-radio-button>
                            <mat-radio-button value="pulley">Pulley Belt Drive</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <ng-container *ngIf="isPulleyDrive">
                    <div class="acf-row acf-row--highlighted">
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Driver Pulley Diameter</mat-label>
                            <input matInput type="number" formControlName="driver_pulley_diameter" min="0">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Driven Pulley Diameter</mat-label>
                            <input matInput type="number" formControlName="driven_pulley_diameter" min="0">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Distance Between Shafts</mat-label>
                            <input matInput type="number" formControlName="dist_bt_shaft" min="0">
                        </mat-form-field>
                    </div>
                    <div class="acf-row acf-row--highlighted">
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Belt Number</mat-label>
                            <input matInput type="number" formControlName="belt_no" min="0">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Belt Length</mat-label>
                            <input matInput type="number" formControlName="belt_length" min="0">
                        </mat-form-field>
                    </div>
                </ng-container>
            </div>
        </section>

        <mat-divider *ngIf="!isGear"></mat-divider>

        <!-- ══════════════════════════════════════════════════════════
         SECTION 6 — OTHER CONFIGURATIONS (both)
    ══════════════════════════════════════════════════════════ -->
        <section class="acf-section">
            <div class="acf-section__head">
                <h2 class="acf-section__title">Other Configuration</h2>
            </div>
            <div formGroupName="other_configurations">

                <!-- Mounting -->
                <div class="acf-subsection">
                    <h3 class="acf-subsection__title">Mounting Axis</h3>
                    <div class="acf-row">
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Sensor Mounting Axis</mat-label>
                            <mat-select formControlName="sensor_mounting">
                                <mat-option value="PARALLEL_SIDE">Parallel to Machine Shaft (Side)</mat-option>
                                <mat-option value="PARALLEL_TOP">Perpendicular to Machine Shaft</mat-option>
                                <mat-option value="PERPENDICULAR">Axial Direction</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <!-- RTD Locations -->
                <div class="acf-subsection">
                    <h3 class="acf-subsection__title">Temperature Sensor Location (RTD)</h3>
                    <!-- <div class="acf-info-banner" *ngIf="rtd2Disabled">
                        <mat-icon>info</mat-icon>
                        <span>RTD-2 and RTD-3 are disabled for <strong>{{ masterLabel }}</strong>. Only available for
                            EM-Std+RTDs (type=3) and Piezo (type=4).</span>
                    </div> -->
                    <div class="acf-row acf-row--three">
                        <!-- RTD 1 — always enabled -->
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>RTD 1</mat-label>
                            <mat-select formControlName="RTD_1">
                                <mat-option value="MS">Machine Skin</mat-option>
                                <mat-option value="DE">DE Bearing</mat-option>
                                <mat-option value="NDE">NDE Bearing</mat-option>
                            </mat-select>
                            <mat-hint>Always active</mat-hint>
                        </mat-form-field>

                        <!-- RTD 2 — disabled for EM-Mini(1) and EM-Std(2) -->
                        <mat-form-field appearance="outline" class="acf-field"
                            [class.acf-field--disabled-look]="rtd2Disabled">
                            <mat-label>RTD 2</mat-label>
                            <mat-select formControlName="RTD_2">
                                <mat-option value="na">N/A</mat-option>
                                <mat-option value="MS">Machine Skin</mat-option>
                                <mat-option value="DE">DE Bearing</mat-option>
                                <mat-option value="NDE">NDE Bearing</mat-option>
                            </mat-select>
                            <mat-hint *ngIf="rtd2Disabled" class="acf-hint--warn">
                                <mat-icon style="font-size:12px;width:12px;height:12px">lock</mat-icon> Disabled for {{
                                masterLabel }}
                            </mat-hint>
                        </mat-form-field>

                        <!-- RTD 3 — disabled for EM-Mini(1) and EM-Std(2) -->
                        <mat-form-field appearance="outline" class="acf-field"
                            [class.acf-field--disabled-look]="rtd3Disabled">
                            <mat-label>RTD 3</mat-label>
                            <mat-select formControlName="RTD_3">
                                <mat-option value="na">N/A</mat-option>
                                <mat-option value="MS">Machine Skin</mat-option>
                                <mat-option value="DE">DE Bearing</mat-option>
                                <mat-option value="NDE">NDE Bearing</mat-option>
                            </mat-select>
                            <mat-hint *ngIf="rtd3Disabled" class="acf-hint--warn">
                                <mat-icon style="font-size:12px;width:12px;height:12px">lock</mat-icon> Disabled for {{
                                masterLabel }}
                            </mat-hint>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Temperature Compensation -->
                <div class="acf-subsection">
                    <h3 class="acf-subsection__title">Temperature Compensation (°C)</h3>
                    <div class="acf-row acf-row--three">
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Compensation 1</mat-label>
                            <input matInput type="number" placeholder="0" min="0" formControlName="temp_1_comp">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="acf-field"
                            [class.acf-field--disabled-look]="rtd2Disabled">
                            <mat-label>Compensation 2</mat-label>
                            <input matInput type="number" placeholder="0" min="0" formControlName="temp_2_comp">
                            <mat-hint *ngIf="rtd2Disabled" class="acf-hint--warn">
                                <mat-icon style="font-size:12px;width:12px;height:12px">lock</mat-icon> Linked to RTD 2
                            </mat-hint>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="acf-field"
                            [class.acf-field--disabled-look]="rtd3Disabled">
                            <mat-label>Compensation 3</mat-label>
                            <input matInput type="number" placeholder="0" min="0" formControlName="temp_3_comp">
                            <mat-hint *ngIf="rtd3Disabled" class="acf-hint--warn">
                                <mat-icon style="font-size:12px;width:12px;height:12px">lock</mat-icon> Linked to RTD 3
                            </mat-hint>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Vibration Compensation -->
                <div class="acf-subsection">
                    <h3 class="acf-subsection__title">Vibration Compensation</h3>
                    <div class="acf-row acf-row--three">
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Radial (Horizontal)</mat-label>
                            <input matInput type="number" placeholder="1" min="0" formControlName="vib_1_comp">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Tangential (Vertical)</mat-label>
                            <input matInput type="number" placeholder="1" min="0" formControlName="vib_2_comp">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="acf-field">
                            <mat-label>Axial</mat-label>
                            <input matInput type="number" placeholder="1" min="0" formControlName="vib_3_comp">
                        </mat-form-field>
                    </div>
                </div>

            </div>
        </section>

        <mat-divider></mat-divider>

        <!-- ══════════════════════════════════════════════════════════
         SECTION 7 — NETWORK CONFIGURATION (EMsaver only)
    ══════════════════════════════════════════════════════════ -->
        <section class="acf-section" *ngIf="isEmsaver">
            <div class="acf-section__head">
                <h2 class="acf-section__title">Connectivity Configuration</h2>
                <span class="acf-badge acf-badge--ems">EMsaver Only</span>
            </div>
            <div formGroupName="network_configuration" class="acf-row">
                <mat-form-field appearance="outline" class="acf-field">
                    <mat-label>Connectivity Type</mat-label>
                    <input matInput formControlName="connectivity_type" placeholder="Wifi">
                </mat-form-field>
                <mat-form-field appearance="outline" class="acf-field">
                    <mat-label>WiFi SSID *</mat-label>
                    <input matInput formControlName="wifi_ssid" placeholder="Enter SSID">
                    <mat-error
                        *ngIf="form.get('network_configuration.wifi_ssid')?.hasError('required')">Required</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="acf-field">
                    <mat-label>WiFi Password *</mat-label>
                    <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="wifi_password"
                        placeholder="Enter password">
                    <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword">
                        <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <mat-error
                        *ngIf="form.get('network_configuration.wifi_password')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>
        </section>

        <!-- ══════════════════════════════════════════════════════════
         FORM ACTIONS
    ══════════════════════════════════════════════════════════ -->
        <div class="acf-actions">
            <button mat-raised-button color="warm" type="button" (click)="goBack()">
                <mat-icon>cancel</mat-icon> Cancel
            </button>
            <button mat-raised-button color="warm" type="button" (click)="resetForm()">
                <mat-icon>refresh</mat-icon> Reset
            </button>
            <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid || save_loader"
                class="save-btn">

                <mat-progress-spinner *ngIf="save_loader" diameter="18" mode="indeterminate">
                </mat-progress-spinner>

                <mat-icon *ngIf="!save_loader">save</mat-icon>

                <span>{{ save_loader ? '' : 'Save Configuration' }}</span>
            </button>
        </div>

    </form>
</div>